import { useSelector } from 'react-redux';
import { OrderedMap } from 'immutable';

// Hooks
import { useMember } from './use-member';

// Types
import { RequireOnlyOne } from 'Shared/types/_RequireOnlyOne.type';
import { User } from 'Shared/constants/types';

// Selectors
import { getUserByUserId, getUserByUserSlug, getUserByPiUserGuid } from 'Shared/selectors/Users.selectors';

interface UseUserProps {
  id?: number;
  slug?: string;
  piUserGuid?: string;
}

type Props = RequireOnlyOne<UseUserProps, 'id' | 'slug' | 'piUserGuid'>;

export const useUser = ({ id, slug, piUserGuid }: Props) => {
  const selectorResult = useSelector(state => {
    if (id !== undefined) {
      return getUserByUserId(state, { userId: id });
    }
    if (slug !== undefined) {
      return getUserByUserSlug(state, { userSlug: slug });
    }
    if (piUserGuid !== undefined) {
      return getUserByPiUserGuid(state, { piUserGuid });
    }
    return OrderedMap();
  });

  const user: User | null = selectorResult && !selectorResult.isEmpty() ? selectorResult.toJS() : null;

  const isPiUser = !!user?.piUserGuid;
  const { isThirdPartyUser } = useMember({ slug: user?.slug });

  return {
    user,
    displayName: user?.displayName,
    id: user?.id,
    slug: user?.slug,
    isPiUser,
    isThirdPartyUser,
  };
};
